import React from "react";

// 未知の platform / 画像読み込み失敗時に使う汎用リンクアイコン
export const FALLBACK_ICON = "/images/sns/link.svg";

export const SNS_ICON_MAP = {
  instagram: "/images/sns/instagram.svg",
  x: "/images/sns/x.svg",
  facebook: "/images/sns/facebook.svg",
  linkedin: "/images/sns/linkedin.svg",
  youtube: "/images/sns/youtube.svg",
  tiktok: "/images/sns/tiktok.svg",
  line: "/images/sns/line.svg",
  other: FALLBACK_ICON,
};

// 読み込みに失敗しても alt テキストが露出しないようリンクアイコンへ差し替える
// （差し替え後の失敗では再設定しない = 無限ループ防止）
const handleIconError = (e) => {
  const img = e.currentTarget;
  if (img.dataset.fallbackApplied === "true") return;
  img.dataset.fallbackApplied = "true";
  img.src = FALLBACK_ICON;
};

const SnsLinksDisplay = ({ snsLinks }) => (
  <div className="snsLinks">
    {snsLinks.map((link, i) => (
      <a
        key={i}
        href={link.url}
        target="_blank"
        rel="noopener noreferrer"
        className="snsLinks__item"
      >
        <img
          src={SNS_ICON_MAP[link.platform] || FALLBACK_ICON}
          alt={link.platform || "リンク"}
          onError={handleIconError}
        />
      </a>
    ))}
  </div>
);

export default SnsLinksDisplay;
